import React, { useState } from 'react';
import { Button, Input } from '../../../ui';

interface SplitSuggestion {
    clusterA: { h3Cells: string[]; shopCount: number };
    clusterB: { h3Cells: string[]; shopCount: number };
}

interface SplitPreviewProps {
    clusterName: string;
    suggestion: SplitSuggestion;
    onConfirm: (clusterA: { name: string; h3Cells: string[] }, clusterB: { name: string; h3Cells: string[] }) => void;
    onCancel: () => void;
    isSplitting?: boolean;
}

const SplitPreview: React.FC<SplitPreviewProps> = ({
    clusterName,
    suggestion,
    onConfirm,
    onCancel,
    isSplitting = false
}) => {
    const [nameA, setNameA] = useState(`${clusterName} A`);
    const [nameB, setNameB] = useState(`${clusterName} B`);

    const handleConfirm = () => {
        if (!nameA.trim() || !nameB.trim()) return;
        onConfirm(
            { name: nameA.trim(), h3Cells: suggestion.clusterA.h3Cells },
            { name: nameB.trim(), h3Cells: suggestion.clusterB.h3Cells }
        );
    };

    return (
        <div className="p-4 space-y-4 border border-ink/15 rounded-lg bg-paper">
            <h4 className="font-semibold">Split preview</h4>
            <div className="grid grid-cols-2 gap-4">
                <div>
                    <label className="text-xs text-muted-foreground block mb-1">Cluster A</label>
                    <Input
                        value={nameA}
                        onChange={(e) => setNameA(e.target.value)}
                        placeholder="Cluster A name"
                        className="mb-2"
                    />
                    <p className="text-xs text-muted-foreground">
                        {suggestion.clusterA.shopCount} shops · {suggestion.clusterA.h3Cells.length} cells
                    </p>
                </div>
                <div>
                    <label className="text-xs text-muted-foreground block mb-1">Cluster B</label>
                    <Input
                        value={nameB}
                        onChange={(e) => setNameB(e.target.value)}
                        placeholder="Cluster B name"
                        className="mb-2"
                    />
                    <p className="text-xs text-muted-foreground">
                        {suggestion.clusterB.shopCount} shops · {suggestion.clusterB.h3Cells.length} cells
                    </p>
                </div>
            </div>
            <div className="flex gap-2">
                <Button onClick={handleConfirm} disabled={isSplitting || !nameA.trim() || !nameB.trim()}>
                    {isSplitting ? 'Splitting...' : 'Confirm split'}
                </Button>
                <Button variant="outline" onClick={onCancel} disabled={isSplitting}>
                    Cancel
                </Button>
            </div>
        </div>
    );
};

export default SplitPreview;
